import React, { useState } from "react";
import { API } from "./Config";
import logo from "./assets/logo.png";

export default function StaffActivate() {
  const token = new URLSearchParams(window.location.search).get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const activate = async (event) => {
    event.preventDefault();
    setError("");

    if (!token) {
      setError("Invitation token is missing.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setBusy(true);

    try {
      const response = await fetch(`${API}/staff/activate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Unable to activate staff access.");
        return;
      }

      setSuccess(true);
      setPassword("");
      setConfirmPassword("");
      window.history.replaceState({}, "", "/staff-activate");
    } catch {
      setError("Unable to connect. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const field = {
    width: "100%",
    boxSizing: "border-box",
    padding: 12,
    border: "1px solid #d1d5db",
    borderRadius: 8,
    marginTop: 8
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f5f7fb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20
    }}>
      <div style={{
        width: "100%",
        maxWidth: 420,
        background: "white",
        padding: 32,
        borderRadius: 14,
        boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
      }}>
        <div style={{ textAlign: "center" }}>
          <img src={logo} alt="MUKBI" style={{ height: 52 }} />
          <h2>Activate Staff Access</h2>
        </div>

        {success ? (
          <div>
            <p>Your Staff Access account has been activated.</p>
            <a href="/staff-login">Continue to Staff Login</a>
          </div>
        ) : !token ? (
          <p style={{ color: "#b91c1c" }}>
            This invitation link is missing its activation token.
          </p>
        ) : (
          <form onSubmit={activate}>
            <p>Create a password to access your assigned CRM.</p>

            <label htmlFor="staff-password">Password</label>
            <input
              id="staff-password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="new-password"
              required
              style={field}
            />

            <p style={{ fontSize: 12, color: "#64748b" }}>
              Minimum 8 characters, including uppercase, lowercase,
              a number and a special character.
            </p>

            <label htmlFor="staff-confirm-password">
              Confirm Password
            </label>
            <input
              id="staff-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
              style={field}
            />

            {error && (
              <p role="alert" style={{ color: "#b91c1c" }}>{error}</p>
            )}

            <button
              type="submit"
              disabled={busy}
              style={{
                ...field,
                background: "#2c3e50",
                color: "white",
                cursor: busy ? "wait" : "pointer",
                marginTop: 20
              }}
            >
              {busy ? "Activating..." : "Activate Account"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
